export const SERP_RESULT_CATEGORIES = [
	'nasza marka',
	'konkurencja',
	'irrelevant',
	'opinie bad',
	'sponsorowany – nasza marka',
	'sponsorowany – konkurencja',
];

export const BAD_REVIEWS_CATEGORY = 'opinie bad';
